export default __webpack_public_path__ + "static/media/installation.683e7df9.png";